import React from 'react'

export const TrendUp = (props) => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.2272 0.949298C10.2272 0.724649 10.4215 0.5 10.6713 0.5H15.5559C15.778 0.5 16 0.724649 16 0.949298V5.89158C16 6.14431 15.778 6.34088 15.5559 6.34088C15.3061 6.34088 15.1119 6.14431 15.1119 5.89158V2.04446L9.20036 8.02578C9.03382 8.19421 8.72852 8.19421 8.56198 8.02578L5.34258 4.74025L0.763228 9.37368C0.596702 9.54211 0.29141 9.54211 0.124892 9.37368C-0.0416305 9.20517 -0.0416305 8.89627 0.124892 8.72776L5.00954 3.78549C5.17606 3.61701 5.48135 3.61701 5.64788 3.78549L8.89506 7.07098L14.4736 1.3986H10.6713C10.4215 1.3986 10.2272 1.20203 10.2272 0.949298Z"
      fill="#000000"
    />
  </svg>
)
